"use client";
import { useMsal } from "@azure/msal-react";
import useUserStore from "../../store/useUserStore";

import "./login.css";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { CircularProgress } from "@mui/material";

export default function LoginPage() {
  const { instance, accounts } = useMsal();
  const [isLoading, setisLoading] = useState(false);
  const navigate = useNavigate();

  const { login, user, tokenId,setIsMobile,isMobile } = useUserStore();


  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 600);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const token = sessionStorage.getItem("token");
    if(token){
      navigate("/dashboard")
    }
    if (accounts.length > 0) {
      console.log("login now")
      const data = {
        token_id: accounts[0]?.idToken,
        first_name: accounts[0]?.name.split(" ")[0],
        last_name: accounts[0]?.name.split(" ")[1],
        email: accounts[0]?.username,
      };

      login(data).then(() => {
        navigate("/dashboard");
      }).catch((error) => {
        console.error("Login failed:", error);
      });

    }
  }, [accounts]);

  return (
    <div className="login-container">
      <div className="login-card">
        <div className="logo-container">
          <svg
            width="43"
            height="43"
            viewBox="0 0 43 43"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M21.5 0C26.4475 0 30.4583 4.01078 30.4583 8.95833L12.5417 8.95833C12.5417 4.01078 16.5524 0 21.5 0Z"
              fill="#0D9488"
            />
            <path
              d="M10.75 21.5C10.75 15.5629 15.5629 10.75 21.5 10.75C27.4371 10.75 32.25 15.5629 32.25 21.5C32.25 27.4371 27.4371 32.25 21.5 32.25C15.5629 32.25 10.75 27.4371 10.75 21.5Z"
              fill="#0D9488"
            />
            <path
              d="M8.95833 12.5417C4.01078 12.5417 0 16.5525 0 21.5C0 26.4475 4.01078 30.4583 8.95833 30.4583V12.5417Z"
              fill="#0D9488"
            />
            <path
              d="M43 21.5C43 26.4476 38.9892 30.4583 34.0417 30.4583V12.5417C38.9892 12.5417 43 16.5525 43 21.5Z"
              fill="#0D9488"
            />
            <path
              d="M12.5417 34.0417C12.5417 38.9892 16.5525 43 21.5 43C26.4475 43 30.4583 38.9892 30.4583 34.0417H12.5417Z"
              fill="#0D9488"
            />
            <path
              d="M34.0417 3.58333C37.0102 3.58333 39.4167 5.9898 39.4167 8.95833H34.0417V3.58333Z"
              fill="#0D9488"
            />
            <path
              d="M34.0417 39.4167C37.0102 39.4167 39.4167 37.0102 39.4167 34.0417H34.0417V39.4167Z"
              fill="#0D9488"
            />
            <path
              d="M3.58333 8.95833C3.58333 5.9898 5.9898 3.58333 8.95833 3.58333V8.95833H3.58333Z"
              fill="#0D9488"
            />
            <path
              d="M3.58333 34.0417C3.58333 37.0102 5.9898 39.4167 8.95833 39.4167V34.0417H3.58333Z"
              fill="#0D9488"
            />
          </svg>
        </div>

        <h1 className="welcome-text">Welcome back</h1>
        <p className="subtitle-text">It's great to see you!</p>
        <p className="instruction-text">Sign in to your account below.</p>

        <button
          className="office-signin-button"
          onClick={() => {
            instance.loginRedirect();
            setisLoading(true);
          }}
        >
          <svg className="microsoft-logo" viewBox="0 0 23 23">
            <path fill="#f35325" d="M1 1h10v10H1z" />
            <path fill="#81bc06" d="M12 1h10v10H12z" />
            <path fill="#05a6f0" d="M1 12h10v10H1z" />
            <path fill="#ffba08" d="M12 12h10v10H12z" />
          </svg>
          Sign in with Office 365
        </button>

        <div className="divider">
          <span className="divider-line"></span>
          <span className="divider-text">Or continue with</span>
          <span className="divider-line"></span>
        </div>

        <button className="credentials-button" onClick={()=> navigate("/manual-login")}>Username and Password</button>
        {isLoading && (
          <CircularProgress
            size={30}
            sx={{ position: "absolute", bottom: "5px", left: "50%" }}
          />
        )}
      </div>
    </div>
  );
}
